import { Controller } from "@hotwired/stimulus"

// Opens the browser print dialog; replaces an inline onclick, which the CSP forbids.
export default class extends Controller {
  print() {
    window.print()
  }
}
